import { render, staticRenderFns } from "./DetailStudent.vue?vue&type=template&id=1d26a4e6"
import script from "../../services/student/detail-student.js?vue&type=script&lang=js&external"
export * from "../../services/student/detail-student.js?vue&type=script&lang=js&external"
import style0 from "../../assets/css/student/detail-student.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports